import React, { lazy, useEffect, Suspense } from 'react';
import {
  isEmpty, getOr, toLower, get,
} from 'lodash/fp';
import { string } from 'prop-types';
import useUserSession from '../Hooks/useUserSession';
import useCurrentUser from '../Hooks/useCurrentUser';
import useRouter from '../Hooks/useRouter';
import useGraphQLErrorExtractor from '../Hooks/useGraphQLErrorExtractor';
import useService from '../Hooks/useService';
import { USER_NOT_FOUND_ERROR, USER_TOKEN } from '../Constants/AppConstants';
import Loader from '../Components/Loader';
import NoAccountScreen from '../Containers/NoAccountScreen';
import ErrorScreen from '../Containers/ErrorScreen';

const Home = lazy(() => import('../Containers/Home'));
const GiveKudosFormScreen = lazy(() => import('../Containers/GiveKudosFormScreen'));

const Layout = ({ service }) => {
  const { currentUser, loading: currentUserLoading } = useCurrentUser();
  const { login, loading: userSessionLoading, error } = useUserSession();
  const { extractError } = useGraphQLErrorExtractor();
  const { currentRoute } = useRouter();
  const { currentService, setService } = useService();

  useEffect(() => {
    setService(service);
  }, [service]);

  useEffect(() => {
    if (currentUserLoading || currentService === 'noaccount') {
      return;
    }

    if (currentService === 'outlook') {
      const emailAddress = get('context.mailbox.userProfile.emailAddress', Office);
      const userEmail = getOr('', 'email', currentUser);

      if (toLower(emailAddress) !== userEmail) {
        localStorage.removeItem(USER_TOKEN);
        login(emailAddress);
      }
    }
  }, [currentUser, currentUserLoading, currentService]);

  const components = {
    '/home': () => <Home />,
    '/post': () => <GiveKudosFormScreen />,
  };

  if (currentService === 'noaccount') {
    return <NoAccountScreen />;
  }

  if (!isEmpty(error) || currentService === 'error') {
    if (extractError(error) === USER_NOT_FOUND_ERROR) {
      return <NoAccountScreen />;
    }
    return <ErrorScreen />;
  }

  if (currentUserLoading || userSessionLoading || !currentUser) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<Loader />}>
      {components[currentRoute] ? components[currentRoute]() : 'Page not found'}
    </Suspense>
  );
};

Layout.propTypes = {
  service: string.isRequired,
};

export default Layout;
